export const LOGIN_ROUTE = '/api/login?include=user.roles'
export const GET_RECOVERY_MOBILES = '/api/password-reset/mobiles'
export const SEND_NEW_PASSWORD = '/api/password-reset/send-new-password'

export const GCE_LOGIN_ROUTE = '/api/gce/login'
export const GCE_REGISTER_ROUTE = '/api/gce/registration'
export const GCE_LOGOUT_ROUTE = '/api/gce/logout'
export const GET_GCE_APPLICANT_PROFILE = '/api/gce/applicant-details'
export const GCE_SUBMIT_DOCUMENTS = '/api/gce/submit-documents/'
export const GCE_APPLICATION_SUBMIT = '/api/gce/submit/'
export const GET_GCE_BILL_INFO_BY_APP_ID = '/api/gce/bill/latest/'

export const REGISTER_ROUTE = '/api/v1/register'
export const REFRESH_TOKEN = '/api/refresh-token'
export const LOGOUT_ROUTE = '/api/logout'

export const HOME_PAGE_INFO = '/api/home-page-info'
export const REGISTRATION = '/api/registration'
export const SEND_CONFIRMATION_CODE = '/api/send-confirmation-code'
export const RESEND_CONFIRMATION_CODE = '/api/resend-confirmation-code'
export const VERIFY_CONFIRMATION_CODE = '/api/verify-confirmation-code'
export const CLAIM_STUDENT_REQUEST = '/api/claim-student-request'

export const GET_STUDENT_PROFILE_PERSONAL = '/api/get-student-profile/personal'
export const GET_STUDENT_PROFILE_ACADEMIC = '/api/get-student-profile/academic'
export const GET_STUDENT_PROFILE_APPLICATION = '/api/get-student-profile/application'

export const UPDATE_STUDENT_PROFILE_PERSONAL = '/api/update-personal-profile'
export const GET_HSC_BOARDS = '/api/hsc-boards'
export const GET_SSC_BOARDS = '/api/ssc-boards'
export const GET_ALT_BOARDS = '/api/alt-boards'
export const GET_YEARS = '/api/year'
export const GET_QUOTAS = '/api/quotas'
export const GET_BILL_FORMAT = '/api/bill-format'
export const GET_UNITS = '/api/units'
export const GET_REQUEST_CHANGE = '/api/request-change'
export const GET_PAID_CORRECTION_BILLS = '/api/paid-correction-bills'

export const UPLOAD_PHOTO = '/api/upload-photo'
export const UPLOAD_SIGNATURE = '/api/upload-signature'

export const GET_APPLICATION_BY_UNIT = '/api/application-by-unit/'
export const PROCESS_APPLICATION = '/api/process-application'
export const GET_REQUEST_APPLICATION_CHANGE = '/api/request-application-change/'

export const GET_COMPLAIN_BY_CODE = '/api/get-complain'
export const POST_COMPLAIN = '/api/save-complain'

export const POST_LAUNCH = 'api/launch?secretkey='
export const LAUNCH_BUTTONS = 'api/launch-buttons'

export const POST_INAUGURAL = 'api/inaugural?secretkey='
export const INAUGURAL_BUTTONS = 'api/inaugural-buttons'

export const GET_DOCS = 'api/get-docs'
export const GET_ADMIT_CARD_DATA = '/api/get-admit-card-data/'
export const CHECK_ADMIT_CARD = '/api/check-admit-card/'

export const GET_SEAT_PLAN = '/api/get-seat-plan/'

export const GET_EXAM_RESULT = '/api/get-exam-result/'
export const CHECK_EXAM_RESULT = '/api/check-exam-result/'

export const CHECK_TEST = '/api/check-subject-choice-card/'

export const GET_SUBJECT_CHOICE = '/api/get-subject-choice/'
export const GET_SUBJECT_CARD = '/api/subject-choice-card/'
export const UPDATE_SUBJECT_CHOICE = '/api/update-subject-choice'
export const POST_SUBJECT_CHOICE = '/api/post-subject-choice/'
export const CHECK_SUBJECT_CARD = '/api/check-subject-choice-card/'

export const GET_SIF = '/api/get-sif'
export const POST_SIF = '/api/sif-data-entry'
export const POST_SIF_NEW = '/api/sif-data-entry-new'

export const GET_SIF_CARD = '/api/get-sif-card'
export const CHECK_SIF_CARD = '/api/check-sif-card/'
export const GET_BANK_SLIP = '/api/get-fees'

export const SET_STILL_INTERESTED = '/api/set-still-interested'
export const GET_STILL_INTERESTED = '/api/get-still-interested'
export const POST_STILL_INTERESTED = '/api/save-still-interested'

export const BKASH_PAYMENT_GATEWAY = '/api/service/bkash/create-payment'
export const DBBL_PAYMENT_GATEWAY = '/api/service/dbbl/init-payment'


export const BKASH_GCE_PAYMENT_GATEWAY = '/api/service/bkash/gce/create-payment'
export const DBBL_GCE_PAYMENT_GATEWAY = '/api/service/dbbl/gce/init-payment'

export const GET_GCE_DATES = '/api/gceDates'